import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { get, isEmpty, isFunction } from 'lodash-es';
import TableRow from '../TableRow';
import TableCell from '../TableCell';
const StyledContainer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
const StyledNoMessageWrapper = styled(TableRow) `
  justify-content: center;
  border-bottom: 0;
`;
const StyledNoMessageText = styled.span `
  font-size: 1rem;
  color: #8d9199;
`;
const StyledCellWrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 0 0.666666667rem;
  box-sizing: border-box;
`;
const renderCells = (columns, data, cellClassName, defaultCellValue, onCellClick) => columns.map(({ name, dataAccessor = '', cellComponent: Cell = TableCell, cellComponentExtraProps = {}, width, style, }) => {
    const value = isFunction(dataAccessor) ? dataAccessor(data) : get(data, dataAccessor);
    const valueToRender = value || defaultCellValue;
    return (React.createElement(StyledCellWrapper, { style: Object.assign({ flex: `1 ${width}` }, style) },
        React.createElement(Cell, Object.assign({ name: name, value: valueToRender, className: cellClassName, onClick: onCellClick, width: width }, cellComponentExtraProps))));
});
const renderContent = (rowData, columns, rowClassName, cellClassName, buildBodyRowStyles = () => ({}), defaultCellValue, onRowClick = () => { }, onCellClick) => rowData.map((data) => (React.createElement(TableRow, { className: rowClassName, data: data, onClick: onRowClick, style: buildBodyRowStyles(data) }, renderCells(columns, data, cellClassName, defaultCellValue, onCellClick))));
const TableBody = forwardRef(({ rowData, columns, className, rowClassName, cellClassName, onRowClick, onCellClick, buildBodyRowStyles, defaultCellValue = '-', noDataMessage = 'No data', }, ref) => (React.createElement(StyledContainer, { className: className, ref: ref }, isEmpty(rowData)
    ? React.createElement(StyledNoMessageWrapper, null,
        React.createElement(StyledNoMessageText, null, noDataMessage))
    : renderContent(rowData, columns, rowClassName, cellClassName, buildBodyRowStyles, defaultCellValue, onRowClick, onCellClick))));
export default TableBody;
